const languages = {
    en: "en",
    vi: "vi"
}
export default languages;